module.exports = __webpack_public_path__ + "static/media/mini-banner-detail.6ccad9bf.svg";